// extracted by mini-css-extract-plugin
module.exports = {"title":"roomstay-blog-all-articles_title__hC4aP","root":"roomstay-blog-all-articles_root__Nnql2"};